import { Plus } from "lucide-react";

interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}

export default function FAQItem({
  question,
  answer,
  isOpen,
  onToggle,
}: FAQItemProps) {
  return (
    <div className="tw-border-b tw-border-gray-200 tw-py-6">
      <button
        onClick={onToggle}
        className="tw-w-full tw-flex tw-justify-between tw-items-center tw-text-left tw-gap-6 tw-group"
      >
        <span 
          className="tw-text-lg md:tw-text-xl tw-font-semibold tw-text-black group-hover:tw-text-[#f39c12] tw-transition-colors"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          {question}
        </span>

        <span
          className={`tw-transition-transform tw-duration-300 ${
            isOpen ? "tw-rotate-45" : "tw-rotate-0"
          } tw-text-black`}
        >
          <svg 
            width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
            strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
          >
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </span>
      </button>

      {/* Animated content */}
      <div
        className={`tw-grid tw-transition-all tw-duration-300 tw-ease-in-out ${
          isOpen ? "tw-grid-rows-[1fr] tw-opacity-100 tw-mt-4" : "tw-grid-rows-[0fr] tw-opacity-0"
        }`}
      >
        <div className="tw-overflow-hidden">
          <p 
            className="tw-text-gray-800 tw-text-lg tw-leading-relaxed tw-max-w-4xl"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            {answer}
          </p>
        </div>
      </div>
    </div>
  );
}
